export default __webpack_public_path__ + "static/media/1.889e3b59.png";